export const releaseDetail = {
    version: '4.5.1',
    date: '30/04/2025',
}